module.exports = "/dist/86172bb829de6be08b92512096b6aca6.woff2";


//////////////////
// WEBPACK FOOTER
// ./~/typeface-montserrat/files/montserrat-latin-400italic.woff2
// module id = 123
// module chunks = 0